const DEV_FALLBACK = 'http://localhost:5001/api';
const PROD_FALLBACK = '/api';

function hasScheme(value: string): boolean {
  return /^https?:\/\//i.test(value);
}

function looksLikeHost(value: string): boolean {
  return /^[a-z0-9.-]+(?::\d+)?(\/.*)?$/i.test(value);
}

function normalizeConfiguredBase(input?: string): string {
  const value = (input || '').trim();
  if (!value) return '';

  if (value.startsWith('/')) return value.replace(/\/$/, '');
  if (hasScheme(value)) return value.replace(/\/$/, '');
  if (looksLikeHost(value)) {
    const isLocalHost = /^(localhost|127\.|0\.0\.0\.0|192\.168\.|10\.|172\.(1[6-9]|2\d|3[0-1])\.)/i.test(value);
    const scheme = isLocalHost ? 'http://' : 'https://';
    return `${scheme}${value}`.replace(/\/$/, '');
  }
  return value.replace(/\/$/, '');
}

function shouldUseWorkerApi(): boolean {
  if (typeof window === 'undefined') return false;
  return /(^|\.)webfoxx\.com$/i.test(window.location.hostname);
}

export function getApiBase(): string {
  if (shouldUseWorkerApi()) return '/api';
  const configured = normalizeConfiguredBase(process.env.REACT_APP_API_URL);
  if (configured) return configured;
  return process.env.NODE_ENV === 'production' ? PROD_FALLBACK : DEV_FALLBACK;
}

export function getMediaOrigin(apiBase: string): string {
  if (apiBase === '/api') {
    if (typeof window !== 'undefined') return window.location.origin;
    return '';
  }
  return apiBase.replace(/\/api\/?$/, '');
}
